import {
  Divider,
  ListItemIcon,
  ListItemText,
  MenuItem,
  Typography,
} from "@mui/material";
import { useCurrentUser } from "src/business-hooks/useCurrentUser";
import { LightBulbIcon } from "src/components/general/Icons/Icons";
import { useRunInsightsMutation } from "src/queries/admin-actions/single-admin-actions.mutation";
import { notify } from "@utils/notification.ts";

export default function TopbarUserAdminActions() {
  const user = useCurrentUser();
  const runInsightsMutation = useRunInsightsMutation();

  if (!user?.is_tenant_admin || user.tenant_id !== 1) return null;

  const runInsights = async () => {
    try {
      await runInsightsMutation.mutateAsync(undefined);
      notify("Insights ran successfully", { variant: "success" });
    } catch {
      // dfetch already notifies on failure
    }
  };

  return (
    <>
      <Divider />
      <Typography sx={{ ml: 2, fontSize: "12px", color: "text.secondary" }}>
        Admin Actions
      </Typography>
      <MenuItem onClick={() => void runInsights()}>
        <ListItemIcon>
          <LightBulbIcon fontSize="small" />
        </ListItemIcon>
        <ListItemText>Run Insights</ListItemText>
      </MenuItem>
    </>
  );
}
